import { useEffect, useRef } from 'react';
import { applyStyles } from '../../utils/styleUtils';
import { renderMilestoneChart } from '../../utils/graphUtils';

const GraphElement = ({ element }) => {
  const containerRef = useRef(null);
  const style = applyStyles(element);
  
  const graphId = useRef(`graph-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`).current;
  
  const graphHeight = parseInt(element.height) || 300;
  const graphWidth = parseInt(element.width) || 340;

  useEffect(() => {
    if (containerRef.current) {
      const options = {
        containerId: graphId,
        // Support both old (leftDateLabel) and new (leftDaysFromToday) formats
        leftDateLabel: element.leftDateLabel,
        rightDateLabel: element.rightDateLabel,
        leftDaysFromToday: element.leftDaysFromToday !== undefined ? parseInt(element.leftDaysFromToday) : 0,
        rightDaysFromToday: element.rightDaysFromToday !== undefined ? parseInt(element.rightDaysFromToday) : 42,
        todayLabel: element.todayLabel || "Today",
        endLabel: element.endLabel || "Significant<br>results",
        width: graphWidth,
        height: graphHeight,
        durationMs: parseInt(element.durationMs) || 1600,
        startColor: element.startColor || "#FFA230",
        endColor: element.endColor || "#A146B0"
      };
      
      requestAnimationFrame(() => {
        renderMilestoneChart(options);
      });
    }
  }, [element, graphId, graphHeight, graphWidth]);

  const containerStyle = {
    ...style,
    width: element.width || '100%',
    height: element.height || `${graphHeight}px`,
    minHeight: `${graphHeight}px`
  };

  return (
    <div 
      ref={containerRef}
      id={graphId}
      className="element-graph"
      style={containerStyle}
    />
  );
};

export default GraphElement;

